var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HMTag',[_vm._v(_vm._s(_vm.$t('EVENTS.LABEL.FREE_EVENT')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }